import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 📄 JavaScript File Support

HawkClient allows you to create **standalone JavaScript files** that can be imported and reused within request-level or collection-level scripts.

This helps you:
- Reuse logic across multiple requests
- Keep scripts clean and modular
- Maintain complex test logic easily

---

## 🧩 Creating a JavaScript File

In the example below, a file named **\`test script.js\`** exports multiple test cases under a single function called **\`testscript\`**.

![JavaScript File Example](/scripts/jsfile.png)

---

## ▶️ Using the JavaScript File in Scripts

The exported function **\`testscript\`** can be imported into a **post-response script**.

Calling:

\`\`\`js
testscript();
\`\`\`

will execute all test cases defined inside the JavaScript file.

![Executing JavaScript File Tests](/scripts/jsfiletest.png)
`;

const JSFile = () => {
    return (
        <MarkDownRenderer
            title="JavaScript File Support"
            markDownText={markdownContent}
        />
    );
};

export default JSFile;
